import React from 'react'
import Map from '../../Map'
import BookingSubtitle from '../BookingSubtitle/BookingSubtitle'
import { ReactComponent as Call } from '../../../../assets/icon/call.svg'
import { usePartnerContext } from '../../../../context/Common/partner'
import { callPhoneNumberInSkt } from '../../../../utils'
import { useMall } from '../../../../store'

// 셔틀버스로 운영되는 더한옥헤리티지 행사 매장의 오시는 길 안내
const HANOK_DIRECTIONS = {
	// 2026 웨딩 쇼케이스
	'thehanok_wedding': [
		{
			label: '전용 셔틀버스 이용',
			text: ' (서울 ↔ 영월 왕복)',
			sub: '용산역 앞 광장 (탑승자 대상 추후 상세 안내)',
		},
		{ label: '대중교통 이용', text: ': 영월역/터미널 하차 후 택시 약 30분 이용' },
		{ label: '자차 이용', text: ': 서울역 기준 약 2시간 30분 소요' },
	],
	// 리추얼 데이 (2026.10.29)
	'6acf08db282b72147ad92932': [
		{
			label: '전용 셔틀버스 이용',
			text: ' (서울 ↔ 영월 왕복)',
			sub: '봉은사역 1번 출구 일주문 앞 (08:30 출발 / 탑승자 대상 추후 상세 안내)',
		},
	],
}

export default function Address() {
	const {
		location_lat: lat,
		location_lng: lng,
		location_address: address,
		mall_phone: phone,
		mall_id: mallId,
	} = useMall(state => state.mall)
	const { partnerName } = usePartnerContext()
	const directions = HANOK_DIRECTIONS[mallId]
	const subtitle = directions
		? '오시는 길'
		: '주소'

	return (
		<div className="address-container">
			<BookingSubtitle subtitle={subtitle}></BookingSubtitle>
			{typeof kakao === 'undefined' ?
				null :
				<Map lat={lat} lng={lng}></Map>}
			<div className="address-box">
				{directions
					? (
						<div className="directions">
							<ul className="direction-list">
								{directions.map(({ label, text, sub }) => (
									<li key={label}>
										<span className="direction-label">{label}</span>{text}
										{sub && <div className="direction-sub"><span className="direction-label">* 탑승지</span>: {sub}</div>}
									</li>
								))}
							</ul>
						</div>
					)
					: (
						<>
							<div className="street-address">
								<div className="text">{address.road} {address.detail}</div>
							</div>
							<div className="domicile-address">
								<div className="text">지번 : {address.address}</div>
							</div>
						</>
					)}
				<div className="address-phone-container">
					<div className="icon-container">
						<Call className="call-icon" />
					</div>
					<div className="phone b1">
						{partnerName === 'skt'
							? (
								<div className="tel" onClick={() => callPhoneNumberInSkt(phone)}>
									<div className="phone-number">{phone}</div>
								</div>
							)
							: (
								<a href={`tel:${phone}`} className="tel">
									<div className="phone-number">{phone}</div>
								</a>
							)}
					</div>
				</div>
			</div>
		</div>
	)
}
